import { render, staticRenderFns } from "./EditRoomType.vue?vue&type=template&id=0a21eb36&"
import script from "./EditRoomType.vue?vue&type=script&lang=js&"
export * from "./EditRoomType.vue?vue&type=script&lang=js&"
import style0 from "./EditRoomType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports